export const languageConstants = [
    { "code": "en" },
    { "code": "ja", "rtl": false }
]